import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { styled } from "@mui/material/styles";
import { useLocation, NavLink } from "react-router-dom";

import MDBox from "components/MDBox";
import MDListRoot from "./MDListRoot";

const CustomListItemButton = styled(ListItemButton)(({ theme, ownerState }) => {
  const { palette } = theme;
  const { selected, color, open } = ownerState;
  return {
    margin: open ? "16px 24px" : "8px 16px",
    paddingLeft: !open && "20px",
    width: !open && "60px",
    height: !open && "60px",
    background: selected && palette[color].main,
    borderRadius: "10.5px",
    color: selected && "white !important",
  };
});
export default function MDList(props) {
  const { color, data } = props;
  const [navs, setNavs] = React.useState(data);
  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState(false);
  const { pathname } = useLocation();

  React.useEffect(() => {
    let temp = navs;
    let temp2;
    let index = temp?.findIndex((n) => n.name === selected);
    if (index !== -1) {
      temp[index].selected = !temp[index].selected;
      temp2 = temp
        ?.filter((f) => f.name !== selected)
        .map((t) => {
          return {
            ...t,
            selected: false,
          };
        });
      setNavs([...temp2, temp[index]]);
    }
  }, [selected, data, open]);
  const [hovered, setHovered] = React.useState(false);
  React.useEffect(() => {
    let temp = navs;
    let temp2;
    let index = temp?.findIndex((n) => n.name === selected);
    if (index !== -1) {
      temp[index].hovered = true
      temp2 = temp
        ?.filter((f) => f.name !== selected)
        .map((t) => {
          return {
            ...t,
            hovered: false,
          };
        });
        if(!hovered){
          temp[index].hovered = false
        }
      setNavs([...temp2, temp[index]]);
    }
  }, [hovered]);

  return (
    <MDBox display="flex" background="primary">
      <Paper elevation={0} sx={{ background: "transparent" }}>
        <MDListRoot component="nav" disablePadding ownerState={{ color }}>
          {navs
            .sort((a, b) => {
              return a.id - b.id;
            })
            .map(
              ({
                name,
                icon,
                expand,
                selected,
                route,
                key,
                selectedIcon,
                onlyRoute,
                hoverdIcon,
                hovered
              }) => {
                return onlyRoute ? null : (
                  <MDBox
                    key={key}
                    sx={{
                      pb: !!expand && selected ? 2 : 0,
                    }}
                  >
                    <NavLink key={key} to={route}>
                      <CustomListItemButton
                        onMouseEnter={() => {
                          setHovered(true);
                          setSelected(name);
                        }}
                        onMouseLeave={() => {
                          setHovered(false);
                          setSelected(name);
                        }}
                        key={name}
                        ownerState={{ selected: pathname === route, color, open: props.open }}
                        alignItems="flex-start"
                        onClick={() => {
                          setSelected(name);
                          setOpen(!open);
                        }}
                        sx={{
                          height: "52px",
                        }}
                      >
                        {pathname === route ? (
                          <ListItemIcon sx={{ color: "inherit" }}>{selectedIcon}</ListItemIcon>
                        ) : hovered ? (
                          <ListItemIcon sx={{ color: "inherit" }}>{hoverdIcon}</ListItemIcon>
                        ) : (
                          <ListItemIcon sx={{ color: "inherit" }}>{icon}</ListItemIcon>
                        )}

                        {props.open && (
                          <ListItemText
                            primary={name}
                            primaryTypographyProps={{
                              fontSize: 12,
                              fontWeight: "medium",
                              lineHeight: "20px",
                              pt: "8px",
                            }}
                            sx={{ my: 0 }}
                          />
                        )}
                        {!!expand && (
                          <KeyboardArrowDown
                            sx={{
                              mr: -1,
                              transform: selected ? "rotate(-180deg)" : "rotate(0)",
                              transition: "0.2s",
                            }}
                          />
                        )}
                      </CustomListItemButton>
                    </NavLink>
                    {selected &&
                      expand?.map((item) => (
                        <NavLink key={item.key} to={item.route}>
                          <CustomListItemButton
                            key={item.name}
                            sx={{ py: 0, minHeight: 42 }}
                            ownerState={{ selected: pathname === item.route, color }}
                          >
                            <ListItemIcon sx={{ color: "inherit" }}>{item.icon}</ListItemIcon>
                            <ListItemText
                              primary={item.name}
                              primaryTypographyProps={{ fontSize: 12 }}
                            />
                          </CustomListItemButton>
                        </NavLink>
                      ))}
                  </MDBox>
                );
              }
            )}
        </MDListRoot>
      </Paper>
    </MDBox>
  );
}
